import { initNavbarDesktop } from '@app/layout/nav/desktop/initNavbarDesktop';
import { initNavbarMobile } from '@app/layout/nav/mobile/initNavbarMobile';

export const initNav = (): void => {
  initNavbarDesktop();
  initNavbarMobile();
};
